"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#FFFFFF', 'light-white', 'Trắng nhạt', {
    tintColor: '#1F3247',
});
//# sourceMappingURL=light-white.js.map